import React from "react";
import { Navigate, Routes, Route, useParams } from "react-router-dom";
import Home from './pages/Home';
import UsPage from "./pages/UsPage";
import MusicPage from "./pages/MusicPage";
import Contact from "./pages/ContactPage";
import CanalizacionPage from "./pages/CanalizacionPage";
import BibliotecaPage from "./pages/BibliotecaPage";
import NoEstaPage from "./pages/NoEstaPage";
import ComoLeerPage from "./pages/ComoLeerPage";
import TreintaYTresPage from './pages/TreintaYTresPage';
import EnsenanzaPage from './pages/EnsenanzaPage';
import VocesPage from "./pages/VocesPage";
import ConservacionPage from "./pages/ConservacionPage";
import { ofreceConservacion } from './config/sites';
import LegalPage from "./pages/LegalPage";
import GraciasPage from "./pages/GraciasPage";
import EntrarPage from "./pages/EntrarPage";
import CuentaPage from "./pages/CuentaPage";
import ScrollToTop from "./components/ScrollToTop";
import { useCatalog } from "./content/hooks";

const LEGACY_SECTION_VOICES = {
  'esenios-jeshua': 'Jeshua',
  'esenios-maria-magdalena': 'María Magdalena',
  'esenios-maria-madre': 'María',
  'esenios-abuela-ana': 'Ana',
  'angeles-y-arcangeles/angeles': 'Los Ángeles',
  'angeles-y-arcangeles/miguel': 'Miguel',
  'angeles-y-arcangeles/metatron': 'Metatrón',
  'angeles-y-arcangeles/gabriel': 'Gabriel',
  'angeles-y-arcangeles/rafael': 'Rafael',
  'angeles-y-arcangeles/chamuel': 'Chamuel',
  'angeles-y-arcangeles/jofiel': 'Jofiel',
  'angeles-y-arcangeles/uriel': 'Uriel',
  'angeles-y-arcangeles/zadquiel': 'Zadquiel'
};

const LegacyChannelingRedirect = () => {
  const { id } = useParams();
  const { items, loading } = useCatalog();
  if (loading) return null;
  const match = items.find((item) => item.id === id);
  return <Navigate to={match ? `/canalizacion/${match.slug}` : '/canalizaciones'} replace />;
};

const Router = ({ childProps }) => {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home {...childProps} />} />

        <Route path="/nosotros" element={<UsPage {...childProps} />} />

        {/* Trabajadores de la Luz: no es una voz, es a quien se le habla (Def 52).
            La ruta es la misma de antes, que servia la API vacia. */}
        {/* Las TRES secciones de voces son LA MISMA PAGINA (Faina, 26-ago:
            «homologa la pagina de esenios con angeles y trabajadores, TODO el
            formato»). Un solo componente es lo unico que garantiza que sigan
            iguales: mientras fueron dos archivos, se separaron dos veces. */}
        <Route path="/trabajadores-de-la-luz" element={<VocesPage familia="tdl" />} />

        {Object.entries(LEGACY_SECTION_VOICES).map(([section, voice]) => (
          <Route key={section} path={`/${section}`}
                 element={<Navigate to={`/canalizaciones?voz=${encodeURIComponent(voice)}`} replace />} />
        ))}
        <Route path="/gaia" element={<Navigate to="/canalizaciones" replace />} />

        <Route path="/musica-mom" element={<MusicPage {...childProps} playlistId={"6tMCcn6SC9VOYeDBO8eqwf"} title="MOM" />} />
        <Route path="/musica-mantras" element={<MusicPage {...childProps} playlistId={"14qnv1ZxAzjUYSVDEU6R10"} title="MANTRAS" />} />
        <Route path="/musica-meditation" element={<MusicPage {...childProps} playlistId={"6WYXMM1sLOg3ObpbL6Fl5S"} title="MEDITATIONS" />} />

        <Route path="/contacto" element={<Contact {...childProps} />} />

        {/* La biblioteca: la caja de buscar y la galeria de voces */}
        <Route path="/canalizaciones" element={<BibliotecaPage />} />
        {/* 33 — el número de la Fundación y las 33 enseñanzas (Faina, 14-sep). */}
        <Route path="/33" element={<TreintaYTresPage />} />
        {/* Def 93: una de las 33 enseñanzas, con sus canalizaciones debajo. */}
        <Route path="/33/:n" element={<EnsenanzaPage />} />
        {/* Cómo leer — enseñar a recibir (Faina, 11-sep). Al lado de la biblioteca. */}
        <Route path="/como-leer" element={<ComoLeerPage />} />
        {/* Las voces, en dos familias (Faina, 26-ago). /voces sigue existiendo
            para los enlaces antiguos y ensena las trece. */}
        <Route path="/voces" element={<VocesPage />} />
        <Route path="/esenios" element={<VocesPage familia="esenios" />} />
        <Route path="/angeles-y-arcangeles" element={<VocesPage familia="angeles" />} />
        {/* 🔴 EXISTIAN LOS ENLACES Y NO LAS PAGINAS (29-ago): cuatro sitios
            apuntaban a /privacidad —los dos del pie, el registro y la pantalla
            de entrar— y la ruta no estaba declarada. Llevaban a una pagina en
            blanco desde siempre. */}
        {/* CONSERVACION (Def 74): la ruta NO EXISTE en el sitio
            internacional. No basta con no enlazarla desde el menu —una
            direccion que responde es una promesa— y el servicio solo se
            puede prestar donde la Fundacion tiene vehiculo legal. */}
        <Route
          path="/conservacion"
          element={ofreceConservacion()
            ? <ConservacionPage />
            /* En .ong la direccion existe pero NO ensena la pagina: devuelve al
               inicio. Dejarla sin declarar dejaba una pantalla en blanco, que es
               peor que no tenerla — el visitante no sabe si se rompio algo o
               si es que ahi no hay nada. */
            : <Navigate to="/" replace />} />
        <Route path="/privacidad" element={<LegalPage cara="privacidad" />} />
        <Route path="/legal" element={<LegalPage cara="legal" />} />
        <Route path="/gracias" element={<GraciasPage />} />
        <Route path="/entrar" element={<EntrarPage />} />
        <Route path="/cuenta" element={<CuentaPage />} />
        {/* 🚪 LA INTRANET SALIÓ DEL SITIO (Faina, 07-10-2026: «sale de la web y
            de todo análisis»). La dirección vieja lleva a la biblioteca para
            que ningún enlace guardado termine en una página en blanco. */}
        <Route path="/corpus" element={<Navigate to="/canalizaciones" replace />} />

        {/* La ficha nueva, servida desde el contenido propio */}
        <Route path="/canalizacion/:slug" element={<CanalizacionPage />} />
        <Route path="/api-canalizacion/:id" element={<LegacyChannelingRedirect />} />

        {/* 🔴 LA ULTIMA, Y TIENE QUE EXISTIR (1-sep). Sin esta linea, cualquier
            direccion equivocada no encajaba con ninguna ruta y la pagina se
            quedaba con SOLO EL PIE: sin mensaje y sin salida. Va la ultima
            porque `*` coincide con todo: puesta antes, se comeria el sitio. */}
        <Route path="*" element={<NoEstaPage />} />
      </Routes>
    </>
  );
};

export default Router;